import { HttpClient } from "@angular/common/http";
import { Component, NgModule, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";

import { AppService } from "../../../views/services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { HeaderService } from "../../services/header.service";
import {
  OrganizationserviceService,
  OrgModel
} from "../../services/organizationservice.service";
import { User, UserOrg } from "../../services/user.model";
import { Configuration } from "../../services/configuration.model";

@Component({
  selector: "app-list",
  templateUrl: "./organization.component.html",
  styleUrls: ["./organization.component.css"]
})
export class OrganizationComponent implements OnInit, OnDestroy {
  OrganizationList: Array<any> = [];
  PendingOrganizationList: Array<any> = [];
  frmOrganization: FormGroup;
  isOrgSelected: boolean = false;
  isApprovedOrg: boolean = false;
  isOrgAttached: boolean = false;
  showPending: boolean = false;
  MessageText: string;
  messages: Array<any>;
  public display = "none";
  modalRef: BsModalRef;
  public checkAttestedUser: any;
  public attestedUser: any;
  public validateAcceptButton: boolean = false;
  public orgList: Array<any> = [];
  public pendingList: Array<any> = [];
  public termAndCondition: string;
  public selectedOrgName: string;
  public userId: string;
  public userName: string;
  public userType: string;
  public orgId: string;
  public mdmId: string;
  public termCondId: string;
  public date: any;
  public self: this;
  private config: Configuration;
  public currentOrg: UserOrg;
  public orgModel: OrgModel;
  public userProfile: User;
  public loading: boolean = true;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private router: Router,
    public fb: FormBuilder,
    public OrgserviceService: OrganizationserviceService,
    public headerService: HeaderService,
    private appService: AppService,
    private _loggerService: LoggerService
  ) {}

  ngOnInit() {
    this.date = new Date();
    this.buildForm();
    this.appService.getConfiguration().then(config => {
      this.config = config;
    });
  }

  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }

  public checkApprovedOrg() {
    let approvable: Array<any> = [];
    if (this.currentOrg.userOrgRoles != null) {
      approvable = this.currentOrg.userOrgRoles.filter(item => {
        return item.roleName === "ACCTAC" || item.roleName === "ACCTC";
      });
    }
    return approvable.length;
  }

  public checkTermAndCond(template) {
    if (this.currentOrg) {
      if (this.checkApprovedOrg()) {
        this.checkAttestedUser = {
          TERM_COND_ID: this.termCondId,
          USER_ID: this.userId,
          ORGANIZATION_ID: this.orgId
        };
        this.subscriptions.push(
          this.OrgserviceService.getAttestedTermAndCondition(
            this.checkAttestedUser
          ).subscribe(response => {
            const user: any = response.body;
            if (response) {
              if (user.count === 0) {
                this.openModal();
              } else {
                sessionStorage.setItem(
                  "selectedOrg",
                  JSON.stringify(this.currentOrg)
                );
                this.headerService.setSelectedOrgDetails(this.currentOrg);
                this.router.navigate(["examinees"]);
              }
            }
          })
        );
      } else {
        this.isApprovedOrg = true;
      }
    } else {
      this.isOrgSelected = true;
    }
  }

  openModal() {
    this.display = "block";
  }
  onCloseHandled() {
    this.display = "none";
  }

  userAttested() {
    this.attestedUser = {
      TERM_COND_ID: this.termCondId,
      USER_ID: this.userId,
      ORGANIZATION_ID: this.orgId,
      USER_TYPE: this.userType,
      CREATED_BY_DS: this.userName,
      UPDATED_BY_DS: this.userName
    };
    this.subscriptions.push(
      this.OrgserviceService.postUserAttestedTermAndCondition(
        this.attestedUser
      ).subscribe(response => {
        if (response) {
          sessionStorage.setItem(
            "selectedOrg",
            JSON.stringify(this.currentOrg)
          );
          this.headerService.setSelectedOrgDetails(this.currentOrg);
          this.router.navigate(["examinees"]);
        }
      })
    );
    this.updateLogs();
  }

  getData() {
    const getTermCond = this.OrgserviceService.getTermAndCondition();
    const getUserProfile = this.appService.getUserProfile();
    return Observable.forkJoin(getTermCond, getUserProfile);
  }
  buildForm() {
    this.frmOrganization = this.fb.group({
      selectedOrganization: [-1, []]
    });

    this.subscriptions.push(
      this.getData().subscribe(response => {
        this.getTermAndCondition(response[0]);
        this.userProfile = response[1];
        this.OrganizationList = this.userProfile.organizations;
        this.userId = this.userProfile.uid;
        this.userName = this.userProfile.userName;
        const organizationArray = Array<any>();
        let sortedOrganization: Array<any> = [];
        if (
          this.OrganizationList === undefined ||
          this.OrganizationList.length === 0
        ) {
          this.isOrgAttached = false;
          this.loading = false;
        } else {
          this.isOrgAttached = true;
          sortedOrganization = this.OrganizationList.sort((a, b) =>
            a.orgName > b.orgName ? 1 : -1
          );
          for (let i = 0; i < sortedOrganization.length; i++) {
            organizationArray.push(
              this.OrgserviceService.getOrgId(
                sortedOrganization[i].mdmId
              ).catch(error => Observable.of(error))
            );
          }
          this.subscriptions.push(
            Observable.forkJoin(organizationArray).subscribe(
              results => {
                if (
                  results.map(r => (r instanceof Error ? null : r)) ||
                  results.map(r => (r instanceof Error ? r : null))
                ) {
                  for (let i = 0; i < results.length; i++) {
                    this.updateOrg(sortedOrganization[i], results[i]);
                  }
                }
              },
              null,
              () => {
                this.loading = false;
              }
            )
          );
        }
      })
    );
  }

  getTermAndCondition(response) {
    const data = response;
    const today = new Date();
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        const endDate = new Date(data[i].END_DT);
        if (endDate > today) {
          this.termAndCondition = data[i].TERM_COND_TX;
          this.userType = data[i].TERM_COND_TYPE;
          this.termCondId = data[i].TERM_COND_ID;
          break;
        }
      }
    }
  }

  updateOrg(Organization, response) {
    let negativeData: Array<any> = [];
    if (response.body) {
      this.orgModel = response.body;
      if (this.orgModel.data != null) {
        negativeData = this.orgModel.data.filter(function(item) {
          return item.keyType === "PARTY ID" && item.statusCode === "A";
        });
      }
    }
    let orgCount = 0;
    orgCount = negativeData.length;
    Organization.orgCount = orgCount;
    const cityName = Organization.cityName;
    const orgName = Organization.orgName;
    const stateCode = Organization.stateCode;
    const countryName = Organization.country;
    if (orgCount === 1) {
      Organization.orgId = negativeData.length ? negativeData[0].keyValue : "";
    }

    if (cityName && stateCode) {
      if (orgCount === 1) {
        Organization.orgDisplayName =
          orgName + ", " + cityName + ", " + stateCode;
      } else if (orgCount === 0) {
        Organization.orgDisplayName =
          orgName +
          ", " +
          cityName +
          ", " +
          stateCode +
          " is not in the TAA system yet. If the organization should be in TAA system please check back in 1 hour as we may not have processed the request yet. If the organization is not here when you check back, please contact ACT Customer Service Support at 877.789.2925.";
      } else {
        Organization.orgDisplayName =
          orgName +
          ", " +
          cityName +
          ", " +
          stateCode +
          " Multiple organizations are attached in the TAA system. In order to continue, please contact ACT Customer Service Support at 877.789.2925.";
      }
    } else {
      Organization.orgDisplayName =
        orgName +
        (cityName === undefined || cityName === "undefined"
          ? ""
          : " , " + cityName + ", ") +
        (countryName === undefined || countryName === "undefined"
          ? " "
          : countryName);
    }

    if (Organization.accessReqDto) {
      for (let j = 0; j < Organization.accessReqDto.length; j++) {
        if (
          Organization.accessReqDto[j].statusCode === "PENDING" &&
          Organization.accessReqDto[j].productName === "TAA"
        ) {
          this.PendingOrganizationList.push(Organization);
          this.showPending = true;
          break;
        }
      }
    }
    if(orgName) {
      this.orgList.push(Organization);
    }
  }

  OrganizationChanged(selectedOrg) {
    this.currentOrg = selectedOrg;
    this.orgId = selectedOrg.orgId;
    this.selectedOrgName = selectedOrg.orgName;
    this.mdmId = selectedOrg.mdmId;
    this.isOrgSelected = false;
  }

  navigateToExaminees() {
    if (this.currentOrg) {
      this.router.navigate(["examinees"]);
    }
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: "ATTESTED_TERMS_INSERT",
      COMPONENT_ID: "ORGANIZATION_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX:
        " Terms and Accommodations attestation: " + this.userProfile.userName,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL:
        "User name:" + this.userProfile.userName + ", Org ID:" + this.orgId
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => {},
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/organization/organization/organization.component.ts